import styled from '@emotion/styled';
import { Tab } from '@mui/material';
import PazPazomatLogo from 'public/Logo/PazLogos/PazPazomatLogo';
import PazYellowLogo from 'public/Logo/PazLogos/PazYellowLogo';
import React from 'react';
import { StyledButton, StyledTabs } from '../styles';

export const StyledPazYellowLogo = styled(PazYellowLogo)`
           width: 97px;
            height: 24px;
        ${(props) => props.theme.breakpoints.only("md")} {
            width: 73px;
            height: 18px;
        }
`;
export const StyledPazPazomatLogo = styled(PazPazomatLogo)`
           width: 97px;
            height: 24px;
        ${(props) => props.theme.breakpoints.only("md")} {
            width: 73px;
            height: 18px;
        }
`;

interface TabsHeaderProps {
    tabIndex: number;
    handleChange: (e: React.SyntheticEvent, newValue: number) => void;
    setTabIndex: (index: number) => void;
    a11yProps: (index: number) => { id: string; 'aria-controls': string };
}

const TabsHeader: React.FC<TabsHeaderProps> = ({ tabIndex, handleChange, a11yProps }) => {
    return (
        <StyledTabs
            value={tabIndex}
            onChange={handleChange}
            aria-label="יצירת קשר"
        >
            <Tab
                label={
                    <StyledButton
                        selected={tabIndex === 0}
                        mobileWidth={132}
                    >
                        שירות לקוחות
                        <StyledPazYellowLogo />
                    </StyledButton>
                }
                {...a11yProps(0)}
            />
            <Tab
                label={
                    <StyledButton
                        selected={tabIndex === 1}
                    >
                        לקוחות פזומט
                        <StyledPazPazomatLogo />
                    </StyledButton>
                }
                {...a11yProps(1)}
            />
        </StyledTabs>
    );
};

export default TabsHeader;
